import React from 'react';
import { AlertCircle, ArrowRight, CheckCircle2 } from 'lucide-react';
import { Action } from '../ui';

export const QuickOrderResults = ({ rows, addToRequest }) => {
  if (!rows) return <div className="quick-results"><h2>Validation results</h2>
    <p className="muted">Your matched products and quantities will appear here.</p></div>;
  const hasErrors = rows.some(row => row.error);
  return <div className="quick-results"><h2>Validation results</h2>
    <div className="table-scroll"><table data-testid="quick-order-results">
      <thead><tr><th>SKU</th><th>Quantity</th><th>Status</th></tr></thead>
      <tbody>{rows.map((row, index) => <tr key={row.id} data-testid={`quick-result-${index}`}>
        <td className="mono">{row.sku}</td><td>{row.quantity}</td>
        <td>{row.error ? <span className="validation-error"><AlertCircle size={14} />{row.error}</span>
          : <span className="validation-ok"><CheckCircle2 size={14} />Ready</span>}</td>
      </tr>)}</tbody>
    </table></div>
    <Action id="quick-add-to-rfq" disabled={!rows.length || hasErrors} onClick={addToRequest}>Add all to RFQ <ArrowRight size={16} /></Action>
    {hasErrors && <p className="form-note">Correct all invalid lines before adding this batch.</p>}
  </div>;
};